import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=27ba1e94&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ba1e94')) {
      api.createRecord('27ba1e94', component.options)
    } else {
      api.reload('27ba1e94', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=27ba1e94&", function () {
      api.rerender('27ba1e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app_versions/edit.vue"
export default component.exports